import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material'
import React from 'react'

export const LoadingDashboard: React.VFC = (): JSX.Element => {
  return (
    <>
      <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: 'repeat(3, 1fr)' }}>
        {[1, 2, 3, 4, 5].map((item, index) => (
          <Paper sx={{ p: '20px' }} key={index}>
            <Skeleton
              sx={{
                height: '28px',
                letterSpacing: '0.15px',
                mb: '8px',
              }}
            />
            <Skeleton
              sx={{
                height: '32px',

                minWidth: '200px',
                mb: '4px',
              }}
            >
              <Skeleton
                sx={{
                  height: '56px',
                }}
              />
            </Skeleton>
            <Skeleton
              sx={{
                height: '56px',
              }}
            />
          </Paper>
        ))}
      </Box>
      <Paper sx={{ mt: '40px' }}>
        <Box p={2}>
          <Skeleton
            sx={{
              height: '40px',
              letterSpacing: '0.15px',
              maxWidth: '150px',
            }}
          />
        </Box>
        <TableContainer
          sx={{ maxHeight: 440, background: '#FFFFFF', minWidth: 400, overflow: 'auto' }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((column, index) => (
                  <TableCell key={index} align={'left'} style={{ minWidth: '110px' }}>
                    <Skeleton
                      sx={{
                        height: '24px',
                      }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {[1, 2, 3, 4, 5].map((item, index) => (
                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((column, i) => (
                    <TableCell key={i} align={'left'}>
                      <Skeleton
                        sx={{
                          height: '16px',
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Paper
        sx={{
          background: '#FFFFFF',
          mt: '40px',
        }}
      >
        <Skeleton
          sx={{
            height: '40px',
            letterSpacing: '0.15px',
            m: '16px',
            boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.12)',
            maxWidth: '150px',
          }}
        />
        <TableContainer component={Paper}>
          <Table
            sx={{ maxHeight: 440 }}
            aria-label="custom pagination table sticky table"
            aria-labelledby="tableTitle"
            size={'medium'}
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {[1, 2, 3, 4].map((column, index) => (
                  <TableCell
                    key={index}
                    align={'left'}
                    style={{ minWidth: 150 }}
                    padding={'normal'}
                  >
                    <Skeleton sx={{ height: '20px' }} />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {[1, 2, 3, 4, 5].map((item, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {[1, 2, 3, 4].map((column, i) => {
                      return (
                        <TableCell key={i} align={'left'} sx={{ p: '13px' }}>
                          <Skeleton sx={{ height: '16px' }} />
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })}
            </TableBody>
            <TableFooter sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
              <TableRow>
                <TableCell>
                  <Skeleton sx={{ height: '30px', width: '200px' }} />
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Paper>
      <Paper
        sx={{
          background: '#FFFFFF',
          mt: '40px',
        }}
      >
        <Skeleton
          sx={{
            maxWidth: '250px',
            height: '40px',
            letterSpacing: '0.15px',
            m: '16px',
            boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.12)',
          }}
        />
        {[1, 2, 3].map((item, index) => (
          <Box
            sx={{
              padding: '16px',
              boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.12)',
            }}
            key={index}
          >
            <Skeleton
              sx={{
                height: '16px',
                width: '200px',
              }}
            />
            <Skeleton
              sx={{
                width: '200px',
                height: '15.6px',
                mb: '12px',
              }}
            />
            <Skeleton
              sx={{
                width: '200px',
                height: '18.2px',
                mb: '12px',
              }}
            />
            <Skeleton sx={{ width: 500, height: 120 }} />

            <Skeleton
              sx={{
                width: '200px',
                height: '20px',
                letterSpacing: '0.4px',
                mb: '20px',
                mt: '20px',
              }}
            />
            <Skeleton
              sx={{
                height: '20px',
                letterSpacing: '0.4px',
                width: '200px',
              }}
            />
          </Box>
        ))}
        <Skeleton
          sx={{
            height: '32px',
            letterSpacing: '0.15px',
            m: '14px 16px',
            mb: '212px',
          }}
        />
      </Paper>
    </>
  )
}
